export const TEAM_CARD_CLICK = "teamCardClick";
export const TEAM_CHAT = "teamChat";
export const START_PAGE_CLICK = "clickTillsammansStartpage";
export const TEAM_PAGE_CLICK = "clickTillsammansTeamPage";
export const MY_TEAMS_PAGE_CLICK = "clickMinaLagsida";
export const TEAM_SEARCH = "teamSearch";
export const SHARED_BET_SEARCH = "sharedBetSearch";
export const PRIVATE_SHARE_SEARCH = "privateShareSearch";
export const MENU_CLICK = "menuClick";
export const LOGIN_STARTED = "loginLoginStarted";
export const LOGIN_COMPLETE = "loginLoginComplete";
export const TERMINATE_TEAM_CLICK = "terminateTeam";
export const PURCHASE_SHARE = "purchaseTillsammansShare";
export const PLACE_BET = "purchase";
export const PRODUCT_PAGE_V85 = "productPageV85";
export const CAPTAIN_EXCLUSIVE_TIP = "openCaptainExclusiveTip";
export const APPLY_TO_JOIN_TEAM = "applyTillsammansTeam";
export const PRE_BOOKING_CLICK = "tillsammansPreRegistration";
export const PRE_BOOKING_EDIT = "tillsammansPreRegistrationChange";
export const MY_COUPON_CLICK = "tillsammansMyShares";
export const TOGGLE_STAKE_CHOICE = "toggleTillsammansStakeChoice";

export type TeamCardClick = {
    event: typeof TEAM_CARD_CLICK;
    clickedSection: string | number;
};

export type TeamChat = {
    event: typeof TEAM_CHAT;
    clickedAction: string;
    teamName: string;
};

export type StartPageEvent = {
    event: typeof START_PAGE_CLICK;
    startPageObject: string;
    resultOfClick: string;
    target?: string | undefined;
    area?: string | undefined;
};

export type TeamPageEvent = {
    event: typeof TEAM_PAGE_CLICK;
    teamPageObject: string;
    resultOfClick?: string | undefined;
    area?: string | undefined;
};

export type MyTeamsPageEvent = {
    event: typeof MY_TEAMS_PAGE_CLICK;
    teamCardObject: string;
    area?: string | undefined;
};

export type TeamSearchEvent = {
    event: typeof TEAM_SEARCH;
    eventAction: string;
    eventType?: string | string[] | undefined;
    value?: string | undefined;
};

export type SharedBetSearchEvent = {
    event: typeof SHARED_BET_SEARCH;
    eventAction: string;
    eventType?: string | string[] | undefined;
    value?: string | undefined;
};

export type PrivateShareSearchEvent = {
    event: typeof PRIVATE_SHARE_SEARCH;
    eventAction: string;
    eventType?: string | string[] | undefined;
    searchText: string | undefined;
};

export type SideMenuClick = {
    event: typeof MENU_CLICK;
    menuType: string;
    menuLabel: string;
};

export type LoginStartedEvent = {
    event: typeof LOGIN_STARTED;
};

export type LoginCompleteEvent = {
    event: typeof LOGIN_COMPLETE;
};

export type TerminateTeamEvent = {
    event: typeof TERMINATE_TEAM_CLICK;
    teamName: string;
};

export type PurchaseShareEvent = {
    event: typeof PURCHASE_SHARE;
    area: string | undefined;
    category: string;
    name: string;
    variant: string;
    cost: number | undefined;
    id: string;
};

type AnalyticsProduct = {
    id: string;
    category: string;
    controlcode?: string | null;
    name: string;
    quantity: string;
    price?: string;
    track: string;
    variant?: string;
};

export type PlaceBetEvent = {
    event: typeof PLACE_BET;
    bettingSystem: string;
    userDate: string;
    ecommerce: {
        purchase: {
            actionField: {
                action: string;
                id: string | undefined;
                revenue: string;
                source?: string;
            };
            products: Array<AnalyticsProduct>;
        };
    };
};

export type CaptainExclusiveTipEvent = {
    event: typeof CAPTAIN_EXCLUSIVE_TIP;
    gameType: string;
    slug?: string;
};

export type ApplyToJoinTeamEvent = {
    event: typeof APPLY_TO_JOIN_TEAM;
    startPageObject: string;
    area: string;
    target?: string | undefined;
};

export type PreBookingClickEvent = {
    event: typeof PRE_BOOKING_CLICK;
    gameType?: string | undefined;
    amount?: string | undefined;
    choice?: string | undefined;
    type?: string | undefined;
};

export type PreBookingEditEvent = {
    event: typeof PRE_BOOKING_EDIT;
    choice: string;
};

export type ToggleStakeChoiceEvent = {
    event: typeof TOGGLE_STAKE_CHOICE;
    choice?: string | undefined;
};

export type MyCouponEvent = {
    event: typeof MY_COUPON_CLICK;
    choice?: string | undefined;
};

export type TillsammansTrackingEvent =
    | TeamCardClick
    | TeamChat
    | StartPageEvent
    | TeamPageEvent
    | SideMenuClick
    | LoginStartedEvent
    | LoginCompleteEvent
    | TeamSearchEvent
    | SharedBetSearchEvent
    | PrivateShareSearchEvent
    | TerminateTeamEvent
    | PurchaseShareEvent
    | PlaceBetEvent
    | CaptainExclusiveTipEvent
    | MyTeamsPageEvent
    | ApplyToJoinTeamEvent
    | PreBookingClickEvent
    | PreBookingEditEvent
    | ToggleStakeChoiceEvent
    | MyCouponEvent;
